/* bvm-annunci.js — LA BARRA ANNUNCI DEL v9 (BVM 21/10/2026, fase 2). Markup: snippets/bvm-annunci.liquid; stile: assets/bvm-annunci.css.
   Come nel v9 (:939-967, :1410-1442):
   · ROTAZIONE ogni 5 s. Ferma con: «riduci movimento», pausa, mouse sopra, fuoco dentro, pannello aperto, pillola sparita (html.bvm-mm-su,
     dopo 80 px di scorrimento), scheda del browser nascosta, sotto i 1000 px. Le frecce cambiano messaggio sempre. I messaggi non
     visibili hanno aria-hidden e i loro comandi escono dal giro del Tab.
   · PANNELLO: con un vero puntatore ((hover: hover) and (pointer: fine)) si apre passando sopra e si chiude 240 ms dopo l'uscita; il clic
     (o il tap) sul messaggio lo apre e lo chiude. Esc lo chiude e rimette il fuoco sul messaggio; lo chiudono anche un clic fuori, lo
     scorrimento oltre gli 80 px e il cambio di larghezza.
   · CARRELLO: quando cambia (il tema ridisegna .mini-cart, cambia il numero del carrello, o arriva product:added) si rilegge /cart.js e
     si riscrivono messaggio, scheda, barra e linea.
   · LA FESTA (coriandoli, raggi, alone; mai con «riduci movimento»), regola di Vittorio del 21/10/2026: UNA volta, quando il carrello
     passa da sotto a sopra la soglia, oppure alla PRIMA apertura del pannello nella sessione se il carrello è già sopra. Poi la scheda
     dice «sbloccata» e basta. Se il carrello torna sotto, il ricordo si cancella e al nuovo superamento riparte una volta. Il ricordo
     sta in sessionStorage (sparisce alla chiusura del browser; se non è disponibile, la festa vale per la sola pagina). */
(function () {
  var radice = document.querySelector('[data-bvm-ann]');
  if (!radice) return;
  function mm(q) { return window.matchMedia ? window.matchMedia(q) : { matches: false }; }
  var largo = mm('(min-width: 1000px)'), fermo = mm('(prefers-reduced-motion: reduce)'), puntatore = mm('(hover: hover) and (pointer: fine)');
  var nastro = radice.querySelector('[data-bvm-ann-nastro]');
  var voci = Array.prototype.slice.call(radice.querySelectorAll('[data-bvm-ann-voce]'));
  var pan = radice.querySelector('[data-bvm-ann-pan]');
  var pausa = radice.querySelector('[data-bvm-ann-pausa]');
  var html = document.documentElement;
  var i = 0, inPausa = false, sopra = false, dentro = false, aperta = false, tChiudi = null, daRiportare = null;

  /* ── i messaggi ── */
  function mostra(n) {
    if (!voci.length) return;
    i = (n % voci.length + voci.length) % voci.length;
    voci.forEach(function (v, k) {
      var qui = k === i, c = v.querySelector('a.bvm-ann__apri, button.bvm-ann__apri');
      v.classList.toggle('is-corrente', qui);
      if (qui) v.removeAttribute('aria-hidden'); else v.setAttribute('aria-hidden', 'true');
      if (c) c.tabIndex = qui ? 0 : -1;
    });
    nastro.style.transform = 'translateY(' + (-i * (voci[0].offsetHeight || 40)) + 'px)';
  }
  function siGira() { return !(fermo.matches || inPausa || sopra || dentro || aperta || document.hidden || html.classList.contains('bvm-mm-su') || !largo.matches); }
  setInterval(function () { if (voci.length > 1 && siGira()) mostra(i + 1); }, 5000);
  var prec = radice.querySelector('[data-bvm-ann-prec]'), succ = radice.querySelector('[data-bvm-ann-succ]');
  if (prec) prec.addEventListener('click', function () { mostra(i - 1); });
  if (succ) succ.addEventListener('click', function () { mostra(i + 1); });
  if (pausa) pausa.addEventListener('click', function () {
    inPausa = !inPausa;
    pausa.setAttribute('aria-pressed', String(inPausa));
    pausa.setAttribute('aria-label', radice.getAttribute(inPausa ? 'data-t-riprendi' : 'data-t-pausa'));
  });
  radice.addEventListener('mouseenter', function () { sopra = true; if (puntatore.matches && pan) { clearTimeout(tChiudi); apri(); } });
  radice.addEventListener('mouseleave', function () { sopra = false; if (puntatore.matches && pan) { clearTimeout(tChiudi); tChiudi = setTimeout(function () { chiudi(false); }, 240); } });
  radice.addEventListener('focusin', function () { dentro = true; });
  radice.addEventListener('focusout', function (e) { if (!radice.contains(e.relatedTarget)) dentro = false; });

  /* ── il pannello ── */
  function apri() {
    if (aperta || !pan) return;
    aperta = true;
    radice.classList.add('is-aperta');
    pan.removeAttribute('inert'); pan.setAttribute('aria-hidden', 'false');
    radice.querySelectorAll('[data-bvm-ann-apri]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    if (radice.getAttribute('data-sped') === 'ok' && !festeggiata()) { ricorda(true); setTimeout(function () { festa(radice.querySelector('[data-bvm-ann-festa-ic]'), true); }, 420); }
  }
  function chiudi(riporta) {
    clearTimeout(tChiudi);
    if (!aperta) return;
    aperta = false;
    radice.classList.remove('is-aperta');
    pan.setAttribute('inert', ''); pan.setAttribute('aria-hidden', 'true');
    radice.querySelectorAll('[data-bvm-ann-apri]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (riporta) {
      var t = daRiportare && daRiportare.tabIndex === 0 ? daRiportare : voci[i] && voci[i].querySelector('[data-bvm-ann-apri]');
      if (t) setTimeout(function () { t.focus(); }, 30);
    }
  }
  if (pan) {
    radice.addEventListener('click', function (e) {
      var b = e.target.closest('[data-bvm-ann-apri]');
      if (!b || !radice.contains(b)) return;
      daRiportare = b; clearTimeout(tChiudi);
      if (aperta) { if (!puntatore.matches || e.detail === 0) chiudi(false); } else apri();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && aperta) { e.stopPropagation(); chiudi(true); } }, true);
    document.addEventListener('pointerdown', function (e) { if (aperta && !radice.contains(e.target)) chiudi(false); }, true);
    window.addEventListener('scroll', function () { if (aperta && window.scrollY > 80) chiudi(false); }, { passive: true });
    window.addEventListener('resize', function () { if (aperta) chiudi(false); });
  }

  /* ── il carrello ── */
  var soglia = parseInt(radice.getAttribute('data-soglia'), 10) || 0;
  var simbolo = radice.getAttribute('data-simbolo') || '€';
  function soldi(cent) {
    var n = Math.max(0, Math.round(cent)), interi = String(Math.floor(n / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'), dec = n % 100;
    return interi + (dec ? ',' + (dec < 10 ? '0' : '') + dec : '') + ' ' + simbolo;
  }
  function scrivi(sel, testo) { var el = radice.querySelector(sel); if (el && el.textContent !== testo) el.textContent = testo; }
  function applica(c) {
    if (radice.getAttribute('data-sped') === 'no' || !soglia) return;
    var prima = parseInt(radice.getAttribute('data-carrello'), 10) || 0;
    var stato = c >= soglia ? 'ok' : (c > 0 ? 'manca' : 'vuoto');
    var manca = (radice.getAttribute('data-t-manca') || '').replace('§', soldi(soglia - c));
    var pct = Math.min(100, c / soglia * 100).toFixed(1) + '%';
    radice.setAttribute('data-carrello', String(c));
    radice.setAttribute('data-sped', stato);
    scrivi('[data-bvm-ann-dice]', stato === 'ok' ? radice.getAttribute('data-t-ok') : (stato === 'manca' ? manca : radice.getAttribute('data-t-sopra')));
    scrivi('[data-bvm-ann-manca-pan]', manca);
    scrivi('[data-bvm-ann-cifre]', soldi(c) + ' / ' + soldi(soglia));
    var tr = radice.querySelector('[data-bvm-ann-traccia]');
    if (tr) { tr.setAttribute('aria-valuenow', String(Math.min(Math.floor(c / 100), Math.floor(soglia / 100)))); tr.firstElementChild.style.width = pct; }
    var li = radice.querySelector('[data-bvm-ann-linea]');
    if (li) li.style.width = pct;
    if (c < soglia) ricorda(false);
    if (prima < soglia && c >= soglia) ricorda(true), setTimeout(function () {
      var v = voci[i] && voci[i].hasAttribute('data-bvm-ann-sped') ? voci[i].querySelector('.bvm-ann__ic-sped') : null;
      festa(v || radice.querySelector('.bvm-ann__fila'), false); alone(radice);
    }, 380);
  }
  var tCarrello = null;
  function rileggi() {
    clearTimeout(tCarrello);
    tCarrello = setTimeout(function () {
      var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { if (c && typeof c.total_price === 'number') applica(c.total_price); })
        .catch(function () {});
    }, 250);
  }
  if (radice.getAttribute('data-sped') !== 'no') {
    document.addEventListener('product:added', rileggi);
    window.addEventListener('pageshow', function (e) { if (e.persisted) rileggi(); });
    if (window.MutationObserver) {
      var guarda = function () {
        var mc = document.querySelector('.mini-cart'), n = document.querySelector('.header__cart-count');
        if (mc) new MutationObserver(rileggi).observe(mc, { childList: true, subtree: true });
        if (n) new MutationObserver(rileggi).observe(n, { childList: true, characterData: true, subtree: true });
      };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', guarda); else guarda();
    }
  }

  /* ── la festa: coriandoli e raggi (v9 :965-975), mai con «riduci movimento» ── */
  var CHIAVE = 'bvm-ann-festa', memoria = false;
  function festeggiata() { try { return window.sessionStorage.getItem(CHIAVE) === '1'; } catch (e) { return memoria; } }
  function ricorda(si) { memoria = si; try { if (si) window.sessionStorage.setItem(CHIAVE, '1'); else window.sessionStorage.removeItem(CHIAVE); } catch (e) {} }
  if (radice.getAttribute('data-sped') !== 'ok') ricorda(false);
  var strato = null;
  function alone(el) { if (fermo.matches || !el) return; el.style.animation = 'none'; void el.offsetWidth; el.style.animation = 'bvmAnnAlone 1.3s ease-out 2'; setTimeout(function () { el.style.animation = ''; }, 2700); }
  function festa(el, grande) {
    if (fermo.matches || !el) return;
    var r = el.getBoundingClientRect(); if (!r.width) return;
    radice.classList.add('is-festa'); clearTimeout(radice.tFesta); radice.tFesta = setTimeout(function () { radice.classList.remove('is-festa'); }, 2600);
    var x = r.left + r.width / 2, y = r.top + r.height / 2;
    if (!strato || !document.body.contains(strato)) {
      strato = document.createElement('div'); strato.className = 'bvm-ann-festa'; strato.setAttribute('aria-hidden', 'true');
      strato.appendChild(document.createElement('canvas')); document.body.appendChild(strato); strato.p = []; strato.va = false;
    }
    var lato = grande ? 340 : 200, raggi = document.createElement('span');
    raggi.className = 'bvm-ann-festa__raggi';
    raggi.style.cssText = 'left:' + (x - lato / 2) + 'px;top:' + (y - lato / 2) + 'px;width:' + lato + 'px;height:' + lato + 'px';
    strato.appendChild(raggi); setTimeout(function () { raggi.remove(); }, 2100);
    var cv = strato.querySelector('canvas'), d = window.devicePixelRatio || 1, W = window.innerWidth, H = window.innerHeight;
    if (!strato.va) { cv.width = W * d; cv.height = H * d; }
    var colori = ['#1E2D7D', '#5A8291', '#72AA9B', '#131c4e', '#ffffff'], n = grande ? 110 : 55, forza = grande ? 11 : 7;
    for (var k = 0; k < n; k++) {
      var a = Math.random() * Math.PI * 2, v = forza * (.35 + Math.random() * .75);
      strato.p.push({ x: x, y: y, vx: Math.cos(a) * v, vy: Math.sin(a) * v - forza * .45, w: 4 + Math.random() * 4, h: 7 + Math.random() * 6, r: Math.random() * 6, vr: (Math.random() - .5) * .35, c: colori[k % colori.length], vita: 0 });
    }
    if (strato.va) return;
    strato.va = true;
    var ctx = cv.getContext('2d');
    (function passo() {
      ctx.setTransform(d, 0, 0, d, 0, 0); ctx.clearRect(0, 0, W, H);
      strato.p = strato.p.filter(function (q) { return q.vita < 150 && q.y < H + 40; });
      strato.p.forEach(function (q) {
        q.vita++; q.vx *= .985; q.vy = q.vy * .985 + .32; q.x += q.vx; q.y += q.vy; q.r += q.vr;
        ctx.save(); ctx.globalAlpha = Math.max(0, 1 - q.vita / 150); ctx.translate(q.x, q.y); ctx.rotate(q.r); ctx.fillStyle = q.c;
        ctx.fillRect(-q.w / 2, -q.h / 2, q.w, q.h * Math.abs(Math.cos(q.vita / 6))); ctx.restore();
      });
      if (strato.p.length) requestAnimationFrame(passo); else { strato.va = false; ctx.clearRect(0, 0, W, H); }
    })();
  }

  mostra(0);
  radice.classList.add('is-pronta');
  if (largo.addEventListener) largo.addEventListener('change', function () { chiudi(false); mostra(i); });
})();
